var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('uploadFile',{attrs:{"url":_vm.url,"params":_vm.params,"mime_types":_vm.mimeTypes,"max_file_size":_vm.maxFileSizeLimit},on:{"whenUpload":_vm.whenUpload,"successCallBackLater":_vm.uploadCallBack,"errorCallBackLater":_vm.errorCallBack}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-405044ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/test.vue
// module id = null
// module chunks = 